"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//import {getUsedDownloadTraffic, getUsedUserLicenses} from '../../actions';

const mapDispatchToProps = (dispatch, props) => {
  return {
    getResult: (0, _redux.bindActionCreators)(props.widget.getResult, dispatch)
  };
};
class DataContainer extends _react.default.Component {
  render() {
    const {
      children,
      widget,
      ...rest
    } = this.props;
    return _react.default.cloneElement(children, {
      dataset: widget,
      getResult: widget.getResult,
      ...rest
    });
  }
}
var _default = exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(DataContainer);
module.exports = exports.default;